import { render } from "./HowDoesItWork​.vue?vue&type=template&id=7695d228&scoped=true"
import script from "./HowDoesItWork​.vue?vue&type=script&lang=js"
export * from "./HowDoesItWork​.vue?vue&type=script&lang=js"

import "./HowDoesItWork​.vue?vue&type=style&index=0&id=7695d228&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7695d228"]])

export default __exports__